class FeaturedStorySlider extends BaseSlider {
  constructor() {
    super();

    this.swiperInstance = null;
    this.slideCount = this.getAttribute('data-slidecount');
    this.viewType = this.getAttribute('data-view-type');
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    if (this.slideCount == 1) {
      console.info('Swiper not initialized. Only one child element.');
      this.showContainer();

      return null;
    }

    this.swiperInstance = new Swiper(this, {
      slidesPerView: 1,
      autoHeight: this.viewType === 'desktop',
      preventInteractionOnTransition: true,
      on: {
        init: () => this.showContainer(),
      },
      pagination: {
        el: this.querySelector('.featured-story-slider-pagination'),
        type: 'bullets',
        clickable: true,
      },
    });
  }
}

customElements.define('featured-store-slider-controller', FeaturedStorySlider);
